import React from 'react'
import Modal from './../index'
import { isEmpty } from 'lodash'
import './modal-send-books.css'

const ModalBooks = ({ book, handleCloseModal, handleSend, list }) => {
  return (
    <div className='modal__container'>
      <Modal.Header title='Livros para enviar' handleCloseModal={handleCloseModal} />
      <Modal.Body>
        <div className='modal-button-send'>
          <a onClick={handleSend} className='button is-success'>ENVIAR</a>
        </div>
        <div className='data-table data-table-modal-send-books'>
          <table>
            <thead>
              <tr>
                <th>Livro</th>
                <th>Disciplina</th>
                <th>Operador</th>
                <th>Série</th>
              </tr>
            </thead>
            <tbody>
              {list.length > 0 &&
                list.map((item) => (
                  <tr key={item.id}>
                    <td>
                      <img className='image' src={item.book.photo_url || `${process.env.PUBLIC_URL}/img/default_pic.png`} alt={`Capa do livro: ${item.book.name}`} />
                      {isEmpty(item.book) ? 'Sem livro' : item.book.name}
                    </td>
                    <td>{isEmpty(item.subject) ? 'Sem disciplina' : item.subject.name}</td>
                    <td>{isEmpty(item.user) ? 'Sem usuário' : item.user.name}</td>
                    <td>{isEmpty(item.grade) ? 'Sem Série' : item.grade.name}</td>
                  </tr>
                ))
              }
            </tbody>
          </table>
        </div>
      </Modal.Body>
    </div>
  )
}

export default ModalBooks



// WEBPACK FOOTER //
// ./src/components/Modal/ModalSendBooks/index.js